const SCROLL_RESTORE_PREFIX = 'appgallop-scroll:';
const SECTION_RESTORE_PREFIX = 'appgallop-section:';
const NAVIGATION_INTENT_KEY = 'appgallop-navigation-intent';

export const getCurrentPathKey = () =>
  `${window.location.pathname}${window.location.search}${window.location.hash}`;

export const getScrollRestoreKey = () => `${SCROLL_RESTORE_PREFIX}${getCurrentPathKey()}`;

export const getSectionRestoreKey = () => `${SECTION_RESTORE_PREFIX}${getCurrentPathKey()}`;

const getActiveSectionId = () => {
  const viewportAnchor = Math.max(96, window.innerHeight * 0.18);
  const sections = Array.from(document.querySelectorAll<HTMLElement>('section[id]'));
  let nearestSection: HTMLElement | null = null;
  let nearestDistance = Number.POSITIVE_INFINITY;

  for (const section of sections) {
    const rect = section.getBoundingClientRect();
    const intersectsAnchor = rect.top <= viewportAnchor && rect.bottom >= viewportAnchor;

    if (intersectsAnchor) {
      return section.id;
    }

    const distance = Math.abs(rect.top - viewportAnchor);
    if (distance < nearestDistance) {
      nearestDistance = distance;
      nearestSection = section;
    }
  }

  return nearestSection?.id ?? '';
};

export const storeCurrentNavigationOrigin = () => {
  try {
    sessionStorage.setItem(getScrollRestoreKey(), String(window.scrollY));

    const sectionId = getActiveSectionId();
    const sectionKey = getSectionRestoreKey();
    if (sectionId) {
      sessionStorage.setItem(sectionKey, sectionId);
    } else {
      sessionStorage.removeItem(sectionKey);
    }
  } catch {
    // Ignore storage failures; native browser restoration may still work.
  }
};

export const storeNavigationIntent = (url: URL) => {
  try {
    sessionStorage.setItem(NAVIGATION_INTENT_KEY, `${url.pathname}${url.search}${url.hash}`);
  } catch {
    // Ignore storage failures; navigation still works.
  }
};

export const consumeNavigationIntentForCurrentPath = () => {
  try {
    const hasClickNavigationIntent = sessionStorage.getItem(NAVIGATION_INTENT_KEY) === getCurrentPathKey();
    if (hasClickNavigationIntent) {
      sessionStorage.removeItem(NAVIGATION_INTENT_KEY);
    }
    return hasClickNavigationIntent;
  } catch {
    return false;
  }
};

export const getStoredOriginSectionId = () => {
  try {
    return sessionStorage.getItem(getSectionRestoreKey()) || '';
  } catch {
    return '';
  }
};

export const getStoredOriginScrollY = () => {
  try {
    return sessionStorage.getItem(getScrollRestoreKey());
  } catch {
    return null;
  }
};
